module.exports = __webpack_public_path__ + "static/media/32.a4122461.svg";